<template>
    <div id="cha">
        <div class="container">
            
            <div class="row">
              <div class="col-sm-4 hashtags">
              <ul class="list-group">
                <li class="list-group-item"><b>Media: </b>solid line</li>
                <li class="list-group-item"><b>SSRN: </b>dashed line</li>
                <li class="list-group-item"><b>arXiv: </b>dotted line</li>
              </ul>
                <form class="form-inline">
                <label v-for="i in chart_grams" v-bind:id="'tag_' + i" class="btn btn-link">
                  <input type="checkbox" autocomplete="off" v-bind:id="i" v-bind:value="i" v-model="kw_search" style="display: none;" v-on:click="toggle_active(i);">#{{stem_dict[i]}}
                  </input>
              </label></form>
            </div> <!-- col-sm-4 -->
             <div class="col-sm-8">
              <br />
            <line-chart chart-id="chart" ref="chart_full" :chartData="chart_filter" :options="options"></line-chart>
        </div> <!-- col-sm-8 -->
        </div> <!-- row -->
    </div> <!-- container -->
</div> <!-- app -->
</template>

<script>
import LineChart from './LineChart.js';
import unigrams from '../assets/coefs_total.json';
import words from '../assets/words_total.json';
import months from '../assets/months.json';
import stem_dict from '../assets/stem_dict.json';
import kw_filter from '../mixins/kw_filter.js';
import toggle_active from '../mixins/toggle_active.js';

function number_range (start, end) {
  return new Array(end - start).fill().map((d, i) => String(i + start));
}
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function floats(n) {
  if (isNumeric(n)) {return parseFloat(n)} else {return 0};
}
function remove(array, element) {
    return array.filter(e => e !== element);
}

function swap(json){
  var ret = {};
  for(var key in json){
    ret[json[key]] = key;
  }
  return ret;
}
var reverse_stem_dict = swap(stem_dict);

export default {
  name: 'cha',
  data () {
    return {
        unigrams: unigrams,
        chart_grams: words,
        kw_search: [],
        kw_old: [],
        dsets: [],
        cols: months,
        stem_dict: stem_dict,
        chart_filter: {'datasets': []},
        // '#2de100', '#e15a00', reserve complementary
        colors: ['#5c4c8e', '#3dbdbe', '#3c3950', '#c24a65'],
        months: number_range(0,25),
        options: {
          responsive: true,
          maintainAspectRatio: true,
          elements: { point: { radius: 0, hoverRadius: 0 } },
          tooltips: {
            enabled: false
          },
          scales: {
            
          xAxes: [
            {
              position: 'bottom',
              gridLines: {
                display: false,
              },
              ticks: {

            autoSkip: false,
                  display: true,
              }
            }]
          }
        },
    }
  },
  computed: {
  },
  components: {
    LineChart
  },
  methods: {
    chart_filter_m: function() {
        // var dsets = [];
        // var colors = ['#e1002d', '#888b95', '#1473e1', '#e18214'];
        var comp_data = [];
        var slowo = '';
        var if_deleted_word = 1;
        console.log(JSON.stringify(this.kw_filter));
        console.log(this.kw_filter.length, this.kw_old.length)
        for (var i = 0; i < this.kw_search.length; i++) {
            slowo = stem_dict[this.kw_filter[i]['word']];
            if (this.kw_old.indexOf(slowo) > -1) {
              continue;
            }
            else {
              if_deleted_word = 0;
              this.kw_old.push(slowo);
            }
            var sources = ['news', 'ssrn', 'arxiv'];
            var sources_display = ['Media', 'SSRN', 'arXiv'];
            var bdash = [[0,0], [10,5], [2,2]];
            for (var s = 0; s < sources.length; s++) {
              comp_data = Array.from(Array(25), () => 0);
              for (var j = 0; j < this.cols.length; j++) {
                console.log(j,this.cols[j],this.kw_filter[i][sources[s] + 'freq_' + this.cols[j]]);
                comp_data[j] = floats(this.kw_filter[i][sources[s] + 'freq_' + this.cols[j]]);
              }
              console.log(slowo, comp_data);
              this.dsets.push({
                label: sources_display[s] + ' - ' + slowo,
                label_word: slowo,
                backgroundColor: 'transparent',
                borderColor: this.colors[this.colors.length-1],
                borderDash: bdash[s],
                borderWidth: 3,
                data: comp_data,
              });
            }
            this.colors.pop();
            return {
                labels: this.cols,
                datasets: this.dsets,
            }
          }
          if (if_deleted_word == 1) {
            console.log(this.kw_old, this.kw_search, this.dsets);
            for (var i = 0; i < this.kw_old.length; i++) {
              if (this.kw_search.indexOf(reverse_stem_dict[this.kw_old[i]]) == -1) {
                var deleted_word = this.kw_old[i];
                this.kw_old = remove(this.kw_old,this.kw_old[i]);
                //break;
              }
            }
            for (var i = 0; i < this.dsets.length; i++) {
              console.log('dsets', this.dsets[i]['label_word'], deleted_word, this.dsets, this.colors.indexOf(this.dsets[i]['borderColor']));
              if (this.dsets[i]['label_word'] == deleted_word) {
                console.log(deleted_word);
                if (this.colors.indexOf(this.dsets[i]['borderColor']) == -1) {
                  this.colors.push(this.dsets[i]['borderColor']);
                }
                this.dsets = remove(this.dsets, this.dsets[i]);
                i--;
              }
            }
            return {
                labels: this.cols,
                datasets: this.dsets,
            }
          }
    }
  },
  watch: {
    kw_search: function(new_data){
        console.log('kw_search');
        this.chart_filter = this.chart_filter_m(new_data);
        this.dsets = this.chart_filter['datasets'];
    },
  },
  mixins: [kw_filter,toggle_active],
}
</script>


// WEBPACK FOOTER //
// src/components/ChartsTotal.vue